
    function openRotate(){
      var r = document.getElementById('rotationslider');
      if(r.style.display== 'unset'){r.style.display="none";}
      else{r.style.display="unset";}
    }

    function openTilt(){
        var r = document.getElementById('tiltslider');
        if(r.style.display== 'unset'){r.style.display="none";}
        else{r.style.display="unset";}
      }

    function initializePanel(){

      var mbtopright = document.getElementsByClassName('mapboxgl-ctrl mapboxgl-ctrl-group')[0]

      var zoomextent = document.createElement('button')
      zoomextent.id = 'zoomextent'
      zoomextent.title = 'Zoom extent'
      zoomextent.innerHTML = 1;

      var rotation = document.createElement('button')
      rotation.id = 'rotation'
      rotation.name = 'mapsubcontrol'
      rotation.title = 'Rotate'
      rotation.onclick = openRotate
      var rotationimage = document.createElement('img')
      rotationimage.className = 'mapboxgl-ctrl-icon'
      rotationimage.style = 'transform: rotate(0deg); width: 20px; height: 20px; margin:auto;'
      rotationimage.src = 'https://brinfaithmap.space/story/img/rotate.png'
      rotation.append(rotationimage)

  

      var rotationslider = document.createElement('div')
      rotationslider.id = 'rotationslider'
      rotationslider.style.display = 'none'
      var rotationslidertitle = document.createElement('div')
      rotationslidertitle.id = 'rotationslidertitle'
      var rotationslidercurrent = document.createElement('label')
      rotationslidercurrent.id = 'rotationslidercurrent'
      rotationslidercurrent.className = 'RTtext'
      rotationslidercurrent.innerHTML = 'Rotate: 0' 

      var rotationsliderRE = document.createElement('a')
      rotationsliderRE.href = 'javascript:void(0)'
      rotationsliderRE.className = 'reset'
      rotationsliderRE.id = 'rotationRE'
      rotationsliderRE.align = 'right'
      //rotationsliderRE.onclick = resetRfun(map)
      rotationsliderRE.title = 'Reset'
      rotationsliderRE.innerHTML = '&#8634'

      var rotationsliderClose = document.createElement('button')
      rotationsliderClose.className = 'close'
      rotationsliderClose.id = 'rotateClose'
      rotationsliderClose.align = 'right'
      rotationsliderClose.onclick = openRotate
      rotationsliderClose.title = 'Close'
      rotationsliderClose.innerHTML = '&#935'
      rotationsliderClose.style = "float:right; height:15px;text-align:center;padding:0;width:15px;line-height:10px"

      rotationslidertitle.append(rotationslidercurrent, rotationsliderRE, rotationsliderClose)

      var rotationsliderinput = document.createElement('input')
      rotationsliderinput.id = 'rotationsliderinput'
      rotationsliderinput.type = 'range'
      rotationsliderinput.min = -180
      rotationsliderinput.max = 180
      rotationsliderinput.step = 0.1
      rotationsliderinput.value = 0
      rotationsliderinput.style.width = '180px'

      rotationslider.append(rotationslidertitle, rotationsliderinput)

      var tilt = document.createElement('button')
      tilt.id = 'tilt'
      tilt.name = 'mapsubcontrol'
      tilt.title = 'Tilt'
      tilt.onclick = openTilt
      var tiltimage = document.createElement('img')
      tiltimage.id = 'tiltimage'
      tiltimage.className = 'mapboxgl-ctrl-icon'
      tiltimage.style = 'transform: rotate(0deg); width: 20px; height: 20px; margin:auto;'
      tiltimage.src = 'https://brinfaithmap.space/story/img/worldwide.png'
      tilt.append(tiltimage)

      var tiltslider = document.createElement('div')
      tiltslider.id = 'tiltslider'
      tiltslider.style.display = 'none'
      var tiltslidertitle = document.createElement('div')
      tiltslidertitle.id = 'tiltslidertitle'
      var tiltslidercurrent = document.createElement('label')
      tiltslidercurrent.id = 'tiltslidercurrent'
      tiltslidercurrent.className = 'RTtext'
      tiltslidercurrent.innerHTML = 'Tilt: 0'

      var tiltsliderRE = document.createElement('a')
      tiltsliderRE.href = 'javascript:void(0)'
      tiltsliderRE.className = 'reset'
      tiltsliderRE.id = 'tiltRE'
      tiltsliderRE.align = 'right'
      //tiltsliderRE.onclick = resetTfun(map)
      tiltsliderRE.title = 'Reset'
      tiltsliderRE.innerHTML = '&#8634'

      var tiltsliderClose = document.createElement('button')
      tiltsliderClose.className = 'close'
      tiltsliderClose.id = 'tiltClose'
      tiltsliderClose.align = 'right'
      tiltsliderClose.onclick = openTilt
      tiltsliderClose.title = 'Close'
      tiltsliderClose.innerHTML = '&#935'
      tiltsliderClose.style = "float:right; height:15px;text-align:center;padding:0;width:15px;line-height:10px"

      tiltslidertitle.append(tiltslidercurrent, tiltsliderRE, tiltsliderClose)

      var tiltsliderinput = document.createElement('input')
      tiltsliderinput.id = 'tiltsliderinput'
      tiltsliderinput.type = 'range'
      tiltsliderinput.min = 0
      tiltsliderinput.max = 85
      tiltsliderinput.step = 0.1
      tiltsliderinput.value = 0
      tiltsliderinput.style.width = '180px'
      tiltslider.append(tiltslidertitle, tiltsliderinput)

      mbtopright.insertBefore(zoomextent, mbtopright.childNodes[3])
      mbtopright.append(rotation, rotationslider, tilt, tiltslider)
    }

export const SideController = () => {
  initializePanel();
}
